/**
 * Un routeur de poche.
 *
 * Trois écrans, et une application installée qu'on ouvre hors ligne : le
 * fragment d'URL suffit. Pas de serveur à configurer, pas de rechargement, et
 * le bouton « précédent » du téléphone fonctionne sans rien de plus.
 */

export type Route =
  | { ecran: 'personnages' }
  | { ecran: 'creation' }
  | { ecran: 'fiche'; id: string }

/** Lit la route courante dans l'URL. Tout ce qui n'est pas reconnu ramène à l'accueil. */
export function routeCourante(): Route {
  const chemin = window.location.hash.replace(/^#/, '')
  if (chemin === '/creation') return { ecran: 'creation' }
  const fiche = /^\/fiche\/(.+)$/.exec(chemin)
  if (fiche?.[1]) return { ecran: 'fiche', id: fiche[1] }
  return { ecran: 'personnages' }
}

export function aller(chemin: string): void {
  window.location.hash = chemin
}
